export default "/kiban/_next/static/images/pban_logo-cb3ef48742daa7a2362ebc7aa36a8cd9.png";